// extracted by mini-css-extract-plugin
export default {"MainOrder":"orderFinalized_MainOrder__DgEiX","LogoImg":"orderFinalized_LogoImg__ft43s"};